import React, { useMemo } from 'react';
import DropDownSearchable from '../../dropDownSearchable';

const ProductConfigurationCard = ({ project, resourceOptions, onUpdate }) => {
    const { ProjectProductConfiguration } = project;

    const fields = useMemo(() => {
        return resourceOptions?.option_types
            ? resourceOptions.option_types
                .filter((optType) => optType.scope === 'Product')
                .map((field) => {
                    const optionChoices = field.options.map((opt) => {
                        return {
                            value: opt.id,
                            label: opt.name,
                        };
                    });
                    return { ...field, optionChoices };
                })
            : [];
    }, [resourceOptions?.option_types]);

    const findSelected = (field) => {
        const varName = field.project_product_config_name;
        const projectValue = ProjectProductConfiguration[varName];
        return field.optionChoices.find((choice) => choice.value === projectValue);
    };

    const handleSelect = (field, selected) => {
        onUpdate([
            {
                sectionName: 'ProjectProductConfiguration',
                fieldName: field.project_product_config_name,
                value: Number(selected.value),
            },
        ]);
    };

    return (
        <div>
            <h3 className="cardTitle">Product Configuration</h3>
            {fields.map((field) => (
                <div
                    key={`productcfg-${field.id}`}
                    className="mb-1 d-flex justify-content-between align-items-center"
                >
                    <label className="fieldLabel">{field.name}</label>
                    <div className="w-50">
                        <DropDownSearchable
                            options={field.optionChoices}
                            value={findSelected(field)}
                            onSelect={(selected) => handleSelect(field, selected)}
                            compact={true}
                        />
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ProductConfigurationCard;
